import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Layout, Breadcrumb, Icon, Typography } from 'antd'
import { Link } from 'react-router-dom'

import { getRoutesByMatchPaths, initialKey } from '../../../config/routes'
import '../../../config/custom-antd.css'
import '../../../assets/css/main.css'

const { Content } = Layout

const ContentWithStyle = styled(Content)`
	min-height: unset !important;
`
const { Text, Title } = Typography

const BreadcrumbByRoute = ({ matchPath, ...res }) => {
	const routes = getRoutesByMatchPaths(matchPath.path)
	// console.log(matchPath.url)
	return (
		<Breadcrumb {...res}>
			{routes.map(
				(route, index) =>
					route.label && (
						<>
							<Breadcrumb.Item key={index}>
								<span style={{ fontSize:"18px" }}>{route.label}</span>
							</Breadcrumb.Item>
						</>
						
					)
			)}
		</Breadcrumb>
	)
}


const Container = ({ match, children, onlyChildren }) =>
	onlyChildren ? (
		children
	) : (
		<>
			<React.Fragment>
				<ContentWithStyle className="px-md-5 py-md-3" style={{ backgroundColor:'#edeef2' }}>
					{
						(
							!match.path.includes("/policy/dashboard/") && 
							!match.path.includes("/hospital") &&
							!match.path.includes("/Leave") &&
							!match.path.includes("/LeaveStudies") &&
							!match.path.includes("/AbstainTime") &&
                     !match.path.includes("/contact") &&
                     !match.path.includes("/welfare") &&
                     !match.path.includes("/news")
						) ?
							<BreadcrumbByRoute matchPath={match} style={{ margin: 16 }} className="breadcrumb-custom pb-3 m-3"/>
						:
							''
					}
					<div className={ match.path.includes("/policy/dashboard/") ? "m-3" : "m-3" }>
						{children}
					</div>
				</ContentWithStyle>
			</React.Fragment>
		</>
		
	)

Container.propTypes = {
	match: PropTypes.object.isRequired,
	children: PropTypes.node,
	onlyChildren: PropTypes.bool
}

export default Container
